import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconEnlargeStyle0 = gravityIconIndividualCss;

const GravityIconEnlarge = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '549dc4a670151b1cd69d6b15e413b97d3e351817', color: this.color, size: this.size }, h("svg", { key: '9004d771a888394080b37a77c9a5c587c19958c7', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'e7a621a9e94dc7254bdfbc1ea6a2d60936543281', d: "M12.966 4H17.6c.22 0 .4.18.4.4v4.634a.4.4 0 0 1-.678.288l-1.778-1.778-2.637 2.638a.5.5 0 0 1-.707 0l-.353-.354a.5.5 0 0 1 0-.707l2.636-2.638-1.8-1.8A.4.4 0 0 1 12.966 4ZM6.48 14.48l2.655-2.657a.5.5 0 0 1 .712 0l.353.354a.5.5 0 0 1 0 .707l-2.659 2.657 1.776 1.776a.4.4 0 0 1-.283.683H4.4a.4.4 0 0 1-.4-.4v-4.634a.4.4 0 0 1 .68-.286l1.8 1.8Z", fill: "currentColor" }))));
    }
};
GravityIconEnlarge.style = GravityIconEnlargeStyle0;

export { GravityIconEnlarge as gravity_icon_enlarge };

//# sourceMappingURL=gravity-icon-enlarge.entry.js.map